import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, NavigationEnd, Event } from '@angular/router';
// import { Observable }        from 'rxjs/Observable';

import { UserService, User } from './';

import { CoreStorageService, CoreStorage, CoreModalService, CoreMessageService } from '../core'




@Component({
  selector: 'user-edit',
  templateUrl: './user-edit.component.html'
})


export class UserEditComponent implements OnInit {

  constructor(
    private service: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private message: CoreMessageService,
    private storage: CoreStorageService,
    // private state: AppState
  ) { }

  obj: User;
  params: any = {};
  @Input() mode = ''; // 'inline' when used as child view
  //@Input() queryIn: any //
  @Input() paramsIn: any // params inherited by parent in inline view
  @Input() objIn: any = {} // obj inherited by parent in inline view
  query: any = {};
  new = false; // true for creation of new entity, false instead
  saveLoading = false;
  saved = false;
  data: {}; // data retrieved by core storage

  tabs = ["Dati Utente"]; //list of tabs
  tab = 0; // tab index


  organizations = [];
  countries = ["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegowina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao, People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia (Slovak Republic)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zambia", "Zimbabwe"]



 identity

  ngOnInit(): void {
    this.identity = this.storage.retrieve('identity') || {};
    // set params if inherited by parent (usually in inline view) then search
    if(this.paramsIn && Object.keys(this.paramsIn).length) {
      this.params = Object.assign({}, this.paramsIn);
      this.search();
    }
    // else subscribe to query and params then search
    else {
      this.route.queryParams.subscribe( queryParams => {
        this.query = queryParams;
      });
      this.route.params.subscribe( params => {
          this.params = Object.assign({}, params);
          this.search();
      });
    }

    // create a new entity with default data
    this.obj = new User().applyModel(Object.assign({
      country: "Italy",
      language: "it",
      terms: true,
      oem:true
    }, this.objIn));

    if(this.identity.user &&  this.identity.user.organization) {
        this.obj['organization'] = this.identity.user.organization.id;
    }

    // retrieve adta from core storage
    this.data = this.storage.retrieve("data");



  }

  // search entity
  search(): void {
    if(this.params['id'] && this.params['id'] != "0") {
      // retrieve ticket details
      this.service.get(this.params['id']).then(res => {
        this.obj = res.models[0];
        if (this.obj.role === 'ROLE_PARENT') {
          // per ora disabilitato
          //this.tabs.push("Configurazione");
        }
      })
    }
    else {
      this.new = true;
    }
  }


  // create or pdate an entioty
  save() : void {
    this.saveLoading = true;
    // patch (UPDATE)
    if(this.obj.id) {
      this.service.patch(this.obj.id, this.obj).then(res => {
        setTimeout(() => {
          this.saveLoading = false
          this.saved = true;
          // trig event in inline mode to notify parents
          if(this.mode == 'inline') {
            res.models[0].loadings['new'] = true;
            this.message.change('user.changed', res.models[0]);
          }
          else {
            setTimeout(() => {
                this.saved = false;
            }, 2000);
          }
        }, 1000);

      }, () => {
        this.saveLoading = false
      })
    }
    //post (CREATE)
    else {
      this.service.post(this.obj).then(res => {
        setTimeout(() => {
          this.tab = 0;
          this.saveLoading = false
          this.saved = true;
          setTimeout(() => {  if(this.mode != 'inline') {this.saved = false;} }, 2000);
          // broadcast event to parent if it's in inline mode
          if(this.mode == 'inline') {
            res.models[0].loadings['new'] = true;
            this.message.change('user.new', res.models[0]);
          }
          // else move to path if is not in inline mode
          else {
            this.router.navigate(['/user/edit/', res.models[0].id], {replaceUrl: true});
          }
        }, 1000);
      }, () => {
        this.saveLoading = false
      })
    }
  }

}
